import React, { FC } from 'react';
import { CoreMenuItem, Item } from './types';
import { SubMenu } from './sub-menu';
import {
  HStack,
  Flex,
  Box,
  Spacer,
  MenuDivider,
  MenuItem as ChakraMenuItem,
  MenuItemOption,
  Checkbox,
} from '@chakra-ui/react';
import { Icon } from '../Icon';
import { Image } from '../Image';
import { Badge as CoreBadge, BadgeVariant } from '../Badge';
import { IconName } from '@fortawesome/fontawesome-svg-core';
import { kebabCase } from 'lodash';

export const MenuItem: FC<CoreMenuItem> = ({ item, isMenuItemOptions, checkboxChange, selectionCount }) => {
  const hasSubmenu = item.items && item.items.length > 0;

  if (hasSubmenu) {
    const currentItem = {
      itemConfig: item.itemConfig,
      text: item.text,
      value: item.value,
    } as Item;
    return (
      <SubMenu
        menuItem={currentItem}
        items={item.items ?? []}
        isMenuItemOptions={isMenuItemOptions}
        checkboxChange={checkboxChange}
        selectionCount={selectionCount}
      />
    );
  }
  if (isMenuItemOptions) {
    return (
      <MenuItemOption icon={null} closeOnSelect={false} value={item.value}>
        <Flex>
          <Box>
            <Checkbox defaultChecked={false} value={item.value} onChange={checkboxChange}>
              {' '}
              {!!item.text && item.text}
            </Checkbox>
          </Box>
          <Spacer />
          <Box>
            {!!item.itemConfig?.rightIconName && (
              <Icon size={'sm'} color={item.itemConfig?.iconColorScheme} iconName={item.itemConfig?.rightIconName} />
            )}
          </Box>
        </Flex>
      </MenuItemOption>
    );
  }
  if (item.isDivider) {
    return <MenuDivider />;
  }
  if (item.itemConfig?.href) {
    return (
      <ChakraMenuItem onClick={item.onClick} as="a" href={item.itemConfig?.href}>
        {!!item.text && <> {item.text} </>}
      </ChakraMenuItem>
    );
  }
  return (
    <ChakraMenuItem
      data-action={kebabCase(item.text)}
      onClick={item.onClick}
      closeOnSelect={!hasSubmenu}
      icon={
        item.itemConfig?.iconName && (
          <Icon color={item.itemConfig?.iconColorScheme} iconName={item.itemConfig?.iconName as IconName} />
        )
      }
    >
      <RegularMenuItem item={item} />
    </ChakraMenuItem>
  );
};
export const RegularMenuItem: FC<CoreMenuItem> = ({ item, selectionCount }) => {
  return (
    <HStack>
      {!!item.itemConfig?.imagePath && (
        <Box>
          <Image path={item.itemConfig?.imagePath} width={'32px'} height={'32px'} />
        </Box>
      )}
      <Box flexGrow={1}>
        {!!item.text && item.text}
        {!!item.itemConfig?.description && (
          <Box as="small" display="block">
            {item.itemConfig?.description}
          </Box>
        )}
      </Box>
      {selectionCount && (
        <CoreBadge colorScheme="neutral" variant={BadgeVariant.subtle}>
          {selectionCount}
        </CoreBadge>
      )}
      {!!item.itemConfig?.rightIconName && <Icon size={'sm'} iconName={item.itemConfig?.rightIconName} />}
    </HStack>
  );
};
